(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.directive('smallHelpQuestionmark', ['$stateParams', '$uibModal', 'HelpCategoryEnum', SmallHelpQuestionmarkFn]);

    /* help questionmark directive */
    function SmallHelpQuestionmarkFn($stateParams, $uibModal, HelpCategoryEnum) {
        var directive = {
            restrict: 'E',
            link: link,
            template: '<i class="fa fa-question-circle fa-lg"></i>'
        };
        return directive;

        function link(scope, element) {

            // show help
            scope.open = function () {

                var helpCategoryItem = null;

                // find helpCategory
                angular.forEach(HelpCategoryEnum, function (helpCategory) {
                    if (helpCategory.value === $stateParams.helpCategory) {
                        helpCategoryItem = helpCategory;
                    }
                });

                //helpcategory is set
                if (helpCategoryItem !== undefined && helpCategoryItem !== null && helpCategoryItem !== '') {
                    // open modal
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        keyboard: false,
                        animation: true,
                        templateUrl: '/app/help/templates/help-view.template.html',
                        controller: 'HelpViewController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            helpCategory: function () {
                                return helpCategoryItem;
                            },
                            helpList: ['HelpService', function (HelpService) {
                                return HelpService.query(helpCategoryItem.value);
                            }]
                        }
                    });
                }
            };
        }
    }
})();